import { ScrollToTop } from '@/components/common';
import { AppRoutes } from './routes';

export default function App() {
  return (
    <>
      <ScrollToTop />
      <AppRoutes />
    </>
  );
}
